"use strict";
//German
const messages = {
  'ALERT-MIC': 'Missing Microphone',
  'ALERT-SPEAKER': 'Missing Speaker',
  'AUDIOCONTROLS-INPUT-HEADING': 'Eingang',
  'AUDIOCONTROLS-OUTPUT-HEADING': 'Ausgabe',
  'AUDIOCONTROLS-CANCEL-BTN-LABEL': 'Stornieren',
  'AUDIOCONTROLS-SAVE-BTN-LABEL': 'Sparen',
  'BACK-BTN-LABEL': 'Zurück',
  'CALLCONTROLS-MUTE-BTN-LABEL' : 'Stumm',
  'CALLCONTROLS-HOLD-BTN-LABEL' : 'Halten',
  'CALLCONTROLS-AUDIO-BTN-LABEL' : 'Audio',
  'CALLCONTROLS-KEYPAD-BTN-LABEL' : 'Tastenfeld',
  'CALLCONTROLS-TRANSFER-BTN-LABEL' : 'Übertragung',
  'CALLCONTROLS-NEWCALL-BTN-LABEL' : 'Neuer Anruf',
  'CALLCONTROLS-HANGUP-BTN-LABEL' : 'Auflegen',
  'CALLLIST-NOCALL' : 'Kein Gespräch',
  'CANCEL-BTN-LABEL' : 'Stornieren',
  'EMAIL-PLACEHOLDER' : 'E-Mail-Addresse',
  'INCOMINGCALL-HEADER' : 'Eingehender Anruf',
  'INCOMINGCALL-ACCEPT' : 'Akzeptieren',
  'INCOMINGCALL-DECLINE' : 'Ablehnen',
  'INCOMINGCALL-VOICEMAIL' : 'Senden an Voicemail',
  'LOGIN-INPUT-EMAIL-PLACEHOLDER' :' E-Mail Adresse eingeben',
  'LOGIN-INPUT-PASSWORD-PLACEHOLDER' : 'Passwort eingeben',
  'LOGIN-CHECKBOX-LABEL' : 'Erinnere dich an Mich',
  'LOGIN-FORGOTPASSWORD-LINK' : 'Passwort vergessen?',
  'LOGIN-SIGNIN-BTN-LABEL' : 'Anmelden',
  'LOGIN-FORGOTPW-INFO-TEXT' : 'Geben Sie einfach Ihre E-Mail -Adresse Ihr Passwort zurücksetzen können.',
  'LOGIN-INPUT-PASSWORD-ERROR' : 'Bitte geben Sie komplette passwort',
  'LOGIN-INPUT-EMAIL-ERROR' : 'Bitte eine gültige Email eingeben',
  'LOGIN-RESETPW-INPUT-PASSWORD-ERROR': 'Die Passwörter müssen übereinstimmen',
  'LOGIN-FORGOTPW-RESETPASSWORD-BTN-LABEL' : 'zurückstellen',
  'LOGIN-RESETPW-INFO-TEXT' : ', Sie Ihr Passwort ändern. Das Passwort muss mindestens einen Buchstaben , keine Leerzeichen enthalten , nicht mit @ beginnen , und 8 oder mehr Zeichen.',
  'LOGIN-RESETPW-INPUT-PASSWORD-PLACEHOLDER' : 'Neues Kennwort',
  'LOGIN-RESETPW-INPUT-REPEATPASSWORD-PLACEHOLDER' : 'Passwort wiederholen',
  'LOGIN-RESETPW-CHANGE-BTN-LABEL' : 'Veränderung',
  'LOGIN-RESETPW-NOTNOW-BTN-LABEL' : 'Nstornieren',
  'SETTINGS-VIEWALERT-BTN-LABEL' : 'Ansicht Alerts',
  'SETTINGS-VERSION' : 'version ',
  'SETTINGS-HELPDOC-BTN-LABEL' : 'Hilfe Dokumentation',
  'SETTINGS-CHECKBOX-LABEL' : 'Aktivieren',
  'SETTINGS-CHECKBOX-HEADER' : 'Immer oben?',
  'SETTINGS-CLOSEALERTS-BTN-LABEL' : 'Schließen Alerts',
  'SETTINGS-LOGOUT-BTN-LABEL' : 'Ausloggen',
  'SETTINGS-SELECT-EXTENSION-HEADER': 'Erweiterung',
  'SETTINGS-SELECT-RINGTONE-HEADER': 'Klingelton',
  'SETTINGS-SELECT-INPUTDEVICE-HEADER': 'Eingabegerät',
  'SETTINGS-SELECT-OUTPUTDEVICE-HEADER': 'Ausgabegerät',
  'SETTINGS-SELECT-INTERFACETHEME-HEADER': 'Schnittstelle Thema',
  'SETTINGS-SELECT-INTERFACELANGUAGE-HEADER': 'Schnittstellensprache',
  'CALLHISTORY-BACK-BTN-LABEL' : 'Zurück',
  'CALLHISTORY-CLEAR-HISTORY-BTN-LABEL' : 'Klar',
  'CALLHISTORY-HEADER' : 'Geschichte',
  'CALLHISTORY-NO-HISTORY-MSG' : 'Keine Anrufliste',
  'ALERTLOG-SETTINGS-BTN-LABEL' : 'Einstellungen',
  'ALERTLOG-CLEAR-ALERT-BTN-LABEL' : 'klar',
  'ALERTLOG-HEADER' : 'Warnungen',
  'ALERTLOG-NO-ALERT-MSG' : 'Keine verfügbaren Warnungen',
  'UTILITIES-STATUS-ONHOLD' : 'In Wartestellung',
  'UTILITIES-STATUS-MUTED' : 'Gedämpft',
  'UTILITIES-STATUS-ACTIVE' : 'Aktiv',
  'UTILITIES-STATUS-DIALING' : 'Dialing',
  'ALERTITEM-HEADING-LOGIN' : 'Anmeldung',
  'ALERTITEM-BODY-INCORRECT-CREDENTIALS-MSG' : 'Der eingegebene Benutzername oder das Passwort sind falsch.',
  'ALERTITEM-HEADING-LOST-NETWORK-CONNECTION' : 'Verlorene Netzwerkverbindung . Überprüfen Sie den Verbindungsstatus .',
  'DIALINPUT-PLACEHOLDER-TEXT' : 'Geben Sie eine Nummer anrufen',
  'CALLDETAILS-HOLD' : 'In Wartestellung',
  'CALLDETAILS-MUTED': 'Gedämpft',
  'CALLLIST-STATUS-ACTIVE': 'Aktiv',
  'CALLLIST-STATUS-DIALING': 'Dialing',
  'CALLHISTORY-STATUS-FAILED': 'Gescheitert',
  'HEADING-STATUS-CONNECTED' : 'In Verbindung gebracht',
  'HEADING-STATUS-OFFLINE' : 'getrennt',
  'BLIND-BTN-LABEL': 'Blind',
  'ATTENDED-BTN-LABEL': 'besucht',
  'SOFTPHONE-DTMF-COMMANDS': "Nummer eingeben",
  'ARIA-LOGIN-SIGNIN-BTN': "Anmeldung Schaltfläche",
  'ARIA-LOGIN-FORGOTPASSWORD-BTN': "Passwort vergessen Schaltfläche",
  'ARIA-CANCEL-BTN': "Abbrechen-Taste",
  'ARIA-LOGIN-FORGOTPW-RESETPASSWORD-BTN': "Passwort zurücksetzen Taste",
  'ARIA-LOGIN-RESETPW-NOTNOW-BTN-LABEL': "Nicht jetzt Taste",
  'ARIA-CALLHISTORY-BACK-BTN-LABEL': 'Zurück-Button',
  'ARIA-CALLHISTORY-CLEAR-HISTORY-BTN-LABEL': 'Schaltfläche Verlauf löschen',
  'ARIA-SETTINGS-LOGOUT-BTN': "Logout-Button",
  'ARIA-SETTINGS-VIEWALERT-BTN': "Warnmeldungen anzeigen Taste",
  'ARIA-SETTINGS-HELPDOC-BTN': "Hilfedokumentation Schaltfläche",
  'ARIA-RESETPW-CHANGE-BTN-LABEL': "Passwort ändern Schaltfläche",
  'ARIA-BACKSPACE-BTN': 'Rücktaste',
  'ARIA-DIALING-INPUT-FIELD': 'Dialing Eingabefeld',
  'ARIA-HEADER': 'Kopfzeile',
  'ARIA-CLEAR-ALERTS-BUTTON': 'Warnungen löschen Taste',
  'ARIA-ALERT-LIST': 'Benachrichtigungsliste',
  'ARIA-CHECKBOX': 'Checkbox',
  'ARIA-SAVE-BTN': 'Schaltfläche Speichern',
  'ARIA-INPUT-FIELD': 'Eingabefeld',
  'ARIA-INPUT': 'Eingang',
  'ARIA-KEYPAD': 'Tastenfeld',
  'ARIA-KEY': 'Schlüssel',
  'ARIA-AUDIO-SLIDER': 'Audio Schieber',
  'ARIA-AUDIO-SLIDER-CONTROL': 'Audio Schieberegler',
  'ARIA-MENU-ITEM': 'Menüpunkt',
  'ARIA-DROP-DOWN-MENU': 'Dropdown-Menü',
  'ARIA-BADGE-BUTTON': 'Abzeichen Button',
  'ARIA-CALL-DETAIL': 'Call detail',
  'ARIA-OPEN-SETTINGS-BUTTON': 'Öffnen Schaltfläche Einstellungen',
  'UPDATE-HEADER': 'Update verfügbar',
  'UPDATE-MSG': 'Möchten Sie jetzt die Anwendung neu starten?',
  'UPDATE-POSTPONE-BUTTON': 'verschieben (1 Min)',
  'UPDATE-UPDATE-BUTTON': 'Aktualisieren',
  'ARIA-UPDATE-POSTPONE-BUTTON': 'Postpone Knopf',
  'ARIA-UPDATE-UPDATE-BUTTON': 'Aktualisieren-Schaltfläche',
  'ACTIVECALL-STATUS-RINGING': 'Klingeln',
  'ACTIVECALL-STATUS-ACTIVE': 'Aktiv',
  'ACTIVECALL-STATUS-DIALING': 'Dialing',
  'ACTIVECALL-STATUS-FAILED': 'Gescheitert',
  'LOGIN-INPUT-SHOW': 'Show',
  'LOGIN-INPUT-HIDE': 'Verstecken',
  'CALLHISTORY-TODAY': 'Heute',
  'CALLHISTORY-YESTERDAY': 'Gestern',
  'ALERT_FORGOT_PASSWORD': 'Passwort vergessen',
  'ALERT_SETTINGS_WILL_APPLY': 'Aktive Anrufe; Einstellungen gelten im Leerlauf .',
  'ALERT_DIALING_OPTIONS': 'Wähloption',
  'ALERT_DIALING_OPTIONS_BODY': 'Fehlende Wählplan Optionen',
  'ALERT_LOGIN': 'Anmeldung',
  'ALERT_SOFTPHONE_EXTENSION': 'Keine Erweiterung Softphone',
  'ALERT_MORE_INFORMATION': 'Für weitere Informationen besuchen Sie:',
  'ALERT_LOST_CONNECTION': 'Verlorene Netzwerkverbindung . Überprüfen Sie den Verbindungsstatus.',
  'ARIA-PLAY-BTN': 'Spieltaste',
  'ARIA-STOP-BTN': 'Stopp-Taste',
  'CONTACTS-STATUS-ONLINE': 'Online',
  'CONTACTS-STATUS-OFFLINE': 'Offline',
  'CONTACTS-STATUS-BUSY': 'Beschäftigt',
  'CONTACTS-STATUS-UNKNOWN': 'Unbekannt',
  'LABELLEDINPUT-LABEL-EMAIL': "E-Mail-Addresse",
  'LABELLEDINPUT-LABEL-PASSWORD': "Passwort",
  'LABELLEDINPUT-LABEL-TEXT': "Text",
  'LABELLEDINPUT-HINT-EMAIL': "Geben Sie eine gültige E-Mail-Adresse unten ein.",
  'LABELLEDINPUT-HINT-PASSWORD': "Geben Sie ein gültiges Passwort unten ein.",
  'LABELLEDINPUT-HINT-TEXT': "Geben Sie unten Text ein.",
  'ARIA-ICON-AREA': 'Icon Bereich',
  'SETTINGS-ADVANCED-LOGGING': "Erweiterte Protokollierung",
  'APPMENU-SETTINGS-BTN-LABEL': "Einstellungen öffnen",
  'APPMENU-HELP-BTN-LABEL': "Hilfedokumentation",
  'APPMENU-LOGOUT-BTN-LABEL': "Ausloggen",
  'APPMENU-VERSION': "Version ",
  'HEADER-SETTINGS-TITLE': "Einstellungen",
  'SETTINGS-NOTIFICATIONS-BTN-LABEL': "Benachrichtigungen",
  'SETTINGS-APPEARANCE-BTN-LABEL': "Das Auftreten",
  'SETTINGS-CONTACTS-BTN-LABEL': "Kontakte",
  'SETTINGS-TROUBLESHOOTING-BTN-LABEL': "Fehlerbehebung",
  'SETTINGS-NOTIFICATIONS-BTN-DESCRIPTION': "Anpassen, wie Sie Updates erhalten.",
  'SETTINGS-APPEARANCE-BTN-DESCRIPTION': "Ändern Sie das Aussehen und das Gefühl der Anwendung.",
  'SETTINGS-CONTACTS-BTN-DESCRIPTION': "Importieren Sie Ihre Kontakte.",
  'SETTINGS-TROUBLESHOOTING-BTN-DESCRIPTION': "Werkzeuge, die Ihnen helfen, herauszufinden, was falsch ist",
  'ARIA-BACK-BTN-LABEL': "Zurück",
  'HEADER-BACK-ARIA-LABEL' : 'zurück',
  'ENTITYLIST-SEARCH-FOUND': "gefunden.",
  'ENTITYLIST-SEARCH-ITEM-PLURAL': "Artikel",
  'ARIA-EVENT-LIST-ADD-NEW-GROUP': 'Neue Gruppe',
  'ENTITYLIST-NO-CONTACTS-FOUND': 'Keine Kontakte gefunden',
  'ENTITYLIST-TRY-IMPORTING': 'Versuchen Sie, einen Kontakt zu importieren oder hinzuzufügen.',
  'ZEROSTATE-IMPORT-BTN-LABEL': 'Einführen',
  'ENTITYLIST-NO-CONTACTS-DESCRIPTION': 'Geben Sie die Nummer ein, um Ihre Kontaktliste zu senden oder zu importieren.',
  'ENTITYLIST-SEARCHBAR-SEARCH-CONTACTS': "Kontakte durchsuchen",
  'CONTACT-DETAILS-CARD-ZERO-STATE-BUTTON-LABEL' : 'Fügen Sie eine Nummer hinzu',
  'CONTACT-DETAILS-CARD-ZERO-STATE-TITLE': 'Keine Kontaktinformationen',
  'CONTACT-DETAILS-CARD-ZERO-STATE-DESCRIPTION': 'Fügen Sie eine Nummer hinzu, um loszulegen',
  'ARIA-CARD-DETAILS-EDIT': 'Bearbeiten',
  'ARIA-CARD-DETAILS-DELETE': 'Löschen',
  'SETTINGS-DEVICES-BTN-LABEL': "Geräte",
  'SETTINGS-DEVICES-BTN-DESCRIPTION': "Ändern Sie, wie Ihre Geräte konfiguriert werden.",
  'HEADER-CONTACTS-ARIA-LABEL' : "kontakte",
  "SETTINGS-CATEGORY-HEADER-TROUBLESHOOTING": "Fehlerbehebung",
  "SETTINGS-TROUBLESHOOTING-CHECKBOX-LABEL": "Erweiterte Protokollierung aktivieren",
  "SETTINGS-TROUBLESHOOTING-DESCRIPTION" : "Wenn aktiviert, erstellt die Anwendung erweiterte Protokolle, um bei der Diagnose von Anwendungsfehlern zu helfen.",
  "SETTINGS-ADVANCED-LOGGING-TITLE" : 'Erweitertes Logging',
  'SETTINGS-CATEGORY-HEADER-ALERTS': "Warnungen",
  "SETTINGS-VIEW-ALERTS-TITLE" : "Benachrichtigungen anzeigen",
  "SETTINGS-VIEW-ALERTS-DESCRIPTION": "Greifen Sie auf eine Aufzeichnung von Warnungen und Protokollen zu.",
  "SETTINGS-NOTIFICATIONS-TITLE": "Klingelton",
  "SETTINGS-NOTIFICATIONS-DESCRIPTION": "Ändern Sie den Klingelton für eingehende Sprachanrufe..",
  'APPMENU-DEFAULT-THEME-BTN-LABEL': "Standard",
  'APPMENU-LIGHT-THEME-BTN-LABEL': "Licht",
  'APPMENU-DARK-THEME-BTN-LABEL': "Dunkel",
  "SETTINGS-APPEARANCE-TITLE-ALWAYS-ON-TOP": "Immer oben",
  "SETTINGS-ALWAYS-ON-TOP-DESCRIPTION": "Wenn aktiviert, wird die Anwendung immer über Ihren anderen Anwendungen angezeigt.",
  'SETTINGS-APPEARANCE-CHECKBOX-LABEL': "Immer oben?",
  'SETTINGS-APPEARANCE-TITLE-THEME': "Thema",
  'SETTINGS-THEMES-DESCRIPTION': "Themes ändern das Gesamtbild der Anwendung.",
  'SETTINGS-APPEARANCE-TITLE-LANGUAGE': "Sprache",
  'SETTINGS-LANGUAGE-DESCRIPTION': "Das Ändern der Sprache ändert es während der Anwendung.",
  'SETTINGS-CATEGORY-HEADER-DEVICE': "Gerät",
  'SETTINGS-CATEGORY-HEADER-CONTACTS': "Kontakte",
  'SETTINGS-CATEGORY-HEADER-APPEARANCE': "Das Auftreten",
  'SETTINGS-CATEGORY-HEADER-NOTIFICATIONS': "Benachrichtigungen",
  'SETTINGS-INPUT-DEVICE-TITLE': "Eingabegerät",
  'SETTINGS-INPUT-DEVICE-DESCRIPTION': "Stellen Sie das Audiogerät ein, das Sie für die Eingabe verwenden möchten..",
  'SETTINGS-OUTPUT-DEVICE-TITLE': "Ausgabegerät",
  'SETTINGS-OUTPUT-DEVICE-DESCRIPTION': "Stellen Sie das Audiogerät ein, das Sie für die Ausgabe verwenden möchten.",
  'SETTINGS-CONTACTS-IMPORT-YOUR-CONTACTS': "Importieren Sie Ihre Kontakte",
  'SETTINGS-CONTACTS-IMPORT-CONTACTS-DESCRIPTION': "Wählen Sie unten Ihre Option aus, um Kontakte zu importieren.",
  'SETTINGS-CONTACTS-SAMPLE-CSV': "Beispiel CSV",
  'SETTINGS-CONTACTS-DOWNLOAD-SAMPLE-CSV-DESCRIPTION': "Wenn Sie die Schaltfläche unten drücken, wird eine Beispiel-CSV-Datei heruntergeladen.",
  'SETTINGS-CONTACTS-BACKUP': 'Sicherung',
  'SETTINGS-CONTACTS-DOWNLOAD-BACKUP-CSV-DESCRIPTION': "Wenn Sie die unten stehende Taste drücken, wird eine CSV-Sicherung Ihrer Kontakte heruntergeladen. Dies wird vor Importen empfohlen.",
  'SETTINGS-CONTACTS-DOWNLOAD-SAMPLE-CSV-BUTTON': 'Beispiel herunterladen',
  'SETTINGS-IMPORT-LAST-SYNC-LABEL': "Importiert",
  'SETTINGS-IMPORT-CONTACTS-SOURCES-BUTTON': "Einführen",
  'SETTINGS-CONTACTS-DOWNLOAD-BACKUP-CSV-BUTTON': 'Sicherung herunterladen',
  'ZEROSTATE-ADD-CONTACT-BTN-LABEL': 'Kontakt hinzufügen',
  'CONTACT-DETAILS-CARD-MODAL-CANCEL-BUTTON': "Stornieren",
  'CONTACT-DETAILS-CARD-MODAL-DELETE-BUTTON': "Löschen",
  'CONTACT-DETAILS-CARD-MODAL-HEADER-DELETE-CONTACT' : "Sind Sie sicher, dass Sie diesen Kontakt löschen möchten?",
  'CONTACT-DETAILS-CARD-MODAL-DESCRIPTION-DELETE-CONTACT': "Wenn Sie diese Aktion abschließen, werden die Informationen des aktuellen Kontakts dauerhaft entfernt. ",
  'CONTACT-DETAILS-FORM-ERROR': 'Ein Feld in der unten stehenden Form hat einen Fehler.',
  'CONTACT-DETAILS-FORM-PERSONAL-INFO-HEADER': 'Persönliche Angaben',
  'CONTACT-DETAILS-FORM-FIRST-NAME-HEADER': 'Vorname',
  'CONTACT-DETAILS-FORM-FIRST-NAME-PLACEHOLDER': 'Bitte Vornamen eingeben',
  'CONTACT-DETAILS-FORM-LAST-NAME-HEADER': 'Nachname',
  'CONTACT-DETAILS-FORM-LAST-NAME-PLACEHOLDER': 'Nachnamen eingeben',
  'CONTACT-DETAILS-FORM-COMPANY-NAME-HEADER': 'Unternehmen',
  'CONTACT-DETAILS-FORM-COMPANY-NAME-PLACEHOLDER': 'Geben Sie den Firmennamen ein',
  'CONTACT-DETAILS-FORM-PHONE-NUMBERS-HEADER': 'Telefonnummern',
  'CONTACT-DETAILS-FORM-PHONE-BTN-LABEL': 'Telefon hinzufügen',
  'CONTACT-DETAILS-FORM-CANCEL-BTN-LABEL': 'Stornieren',
  'CONTACT-DETAILS-FORM-SAVE-BTN-LABEL': 'sparen',
  'CONTACT-DETAILS-FORM-NEW-CONTACT-HEADER': 'Neuer Kontakt',
  'CONTACT-DETAILS-FORM-EDIT-CONTACT-HEADER': 'Kontakt bearbeiten',
  'CONTACT-DETAILS-FORM-INPUT-ERROR': 'Dieses Feld darf nicht leer gelassen werden.',
  'CONTACT-DETAILS-FORM-NUMBER-HEADER':'Nummer',
  'CONTACT-DETAILS-FORM-NUMBER-ERROR':'Bitte geben Sie eine gültige 10-stellige Zahl ein',
  'CONTACT-DETAILS-FORM-NUMBER-PLACEHOLDER':'Nummer eingeben...',
  'CONTACT-DETAILS-FORM-PREFERRED-LABEL':'Bevorzugt?',
  'CONTACT-DETAILS-FORM-SELECT-HOME': 'Zuhause',
  'CONTACT-DETAILS-FORM-SELECT-BUSINESS': 'Geschäft',
  'CONTACT-DETAILS-FORM-SELECT-MOBILE': 'Mobile',
  'CONTACT-DETAILS-FORM-SELECT-OTHER': 'Andere',
  'CONTACT-DETAILS-FORM-SELECT-LABEL': 'Etikette',
  'NUMBER-SELECTION-MODAL-SELECT-NUMBER-TO-CALL': 'Wählen Sie die anzurufende Nummer',
  'NUMBER-SELECTION-MODAL-PREFERRED': 'Bevorzugt',
  'CONTACT-DETAILS-FORM-NUMBER-ERROR-PROP':'Bitte geben Sie eine gültige Zahl ein'
};
module.exports = messages;



// WEBPACK FOOTER //
// ./src/locales/locale-de.js